var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('action-button',{attrs:{"disabled":_vm.u_id==='new',"title":"Download vCard","icon":_vm.$icons.vcf},on:{"action":_vm.downdload}},[_c('iframe',{staticStyle:{"display":"none"},attrs:{"id":"invisible","src":_vm.src}})])}
var staticRenderFns = []

export { render, staticRenderFns }